export const getParams = (paramsName) => {
  const url = new URL(window.location.href);
  return url.searchParams.get(paramsName);
};
